import React, { Fragment, useEffect, useState, useRef } from 'react';
import BannerData from '../model/top/bannerData';
import NewsData/*, { getNewsCategoryName, getDataCategory }*/ from '../model/top/newsData';
import RoadMapData from '../model/top/roadmapData';
import CharacterBannerData from '../model/top/characterBannerData';
import { TopBannerSlider, TopPopupSlider } from './component/bannerSlider';
import { GetPanelPositionRem, AdjustLineXPos, SetArrowHeight } from './component/roadmapLayout';
import SwiperCore from "swiper";
import { LanguageUtils } from "../language/LanguageUtils";
import Header from "./header";

interface ViewProps {
    bannerData: BannerData[];
    charBannerData: CharacterBannerData;
    newsData: NewsData[];
    roadmapData: RoadMapData[];
    isSuccess: boolean;
}

const View:React.FC<ViewProps> = (props: ViewProps) => {
    
    let arrowHeight = 0;

    // ポップアップウインドウの画像
    // 順番：①②号外1（渋谷）③④⑤号外（2万人）⑥
    let popupImageArray = ["zircon_ep1.jpg","zircon_ep2.jpg","zircon_extra.jpg","zircon_ep3.jpg","zircon_ep4.jpg","zircon_ep5.jpg","zircon_extra2.jpg","zircon_ep6.jpg"];
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef<SwiperCore | null>(null);
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);

    const [allowPrev, setAllowPrev] = useState(true);
    const [allowNext, setAllowNext] = useState(true);

      
    // ポップアップウインドウのSwiperの矢印を表示非表示切り替えるために再初期化
    useEffect(() => {
        if (
            swiperRef.current &&
            prevRef.current&&
            nextRef.current&&
            swiperRef.current.params.navigation &&
            typeof swiperRef.current.params.navigation !== "boolean"
        ) {
            // 再初期化
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.destroy();
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, [activeIndex]);
  

    // ポップアップ表示中フラグ
    const [isOpenPopup, setIsOpenPopup] = useState(false);

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);

        // common.min.jsのGetLanguageCookieValueをtop.min.jsでも使いたいので、
        // common.min.jsの読み込み完了待ち
        scriptUrl.onload = () => {
            const scriptUrl2 = document.createElement('script');
            scriptUrl2.type = 'text/javascript';
            scriptUrl2.src = '../assets/js/top.min.js';
            document.body.appendChild(scriptUrl2);
        }
    }, []);

    const buttonRef = useRef<HTMLButtonElement>(null);
    useEffect(() => {
        const timer = setTimeout(() => {
        if (buttonRef.current) {
            buttonRef.current.classList.add('fade-out');
        }
        }, 30000); // 30秒後にフェードアウト

        return () => clearTimeout(timer);        
    }, []);

    useEffect(() => {
        // レイアウト配置
        ChangeLayout();

        // ウィンドウサイズが変更された時レイアウトと画像が変わるので再計算する
        matchMedia('(max-width: 768px)').addEventListener("change", ChangeLayout); 

        // scrollTriggerの開始位置がうまく設定できていなかったので、
        // パネル表示完了まで少し待機させる
        const roadmapSet = setTimeout(() => {
            const scriptUrl3 = document.createElement('script');
            scriptUrl3.type = 'text/javascript';
            scriptUrl3.src = '../assets/js/top-roadmap.min.js';
            document.body.appendChild(scriptUrl3);
        }, 1200);

        return () => {
            matchMedia('(max-width: 768px)').removeEventListener("change", ChangeLayout);
            clearTimeout(roadmapSet);
        }
    },[props.isSuccess]);

    const mediaCheck = window.matchMedia('(max-width: 768px)');
    let imageTopMaskThreshold = 17;

    // レイアウトの配置位置を計算
    function ChangeLayout()
    {
        // パネルの配置位置計算
        let roadmapPos_rem = 0;
        let year = 0;

        for (let i = 0; i < props.roadmapData.length - 1; i++)
        {
            year = 2024 + i;
            let roadmap = document.getElementById("roadmap_" + (year));
            let roadmap_before = document.getElementById("roadmap_" + (year - 1));
            let roadmap_check = document.getElementById("roadmap_" + (year - 2));

            let line = document.getElementById("line_x" + (year));

            if (roadmap_before == null)
            {
                continue;
            }

            let checkHeight = 0;
            if (roadmap_check != null)
            {
                checkHeight = roadmap_check?.clientHeight + parseFloat(window.getComputedStyle(roadmap_check).top);
            }
                
            let topHeight = parseFloat(window.getComputedStyle(roadmap_before).top);

            roadmapPos_rem = GetPanelPositionRem(roadmap_before.clientHeight, topHeight, checkHeight);
            line?.style.setProperty("top", AdjustLineXPos(roadmapPos_rem) + "rem");
            roadmap?.style.setProperty("top", roadmapPos_rem + "rem");
        }

        // 縦矢印の情報取得
        let arrow = document.getElementById("arrow");
        let roadmap = document.getElementById("roadmap_" + (year));
        if (roadmap == null)
        {
            return;
        }
        // 基準となるフォントサイズの取得
        const root = document.documentElement;
        let style = window.getComputedStyle(root).getPropertyValue('font-size');
        let rootFontSize = parseFloat(style);
        let roadmapRem = roadmapPos_rem + (roadmap.clientHeight / rootFontSize);
            
        // 縦矢印の長さをセット
        arrow?.style.setProperty("height", SetArrowHeight(roadmapRem) + "rem");

        //ロードマップエリアにも矢印と同じ値をセット
        let roadmap_area = document.getElementById("roadmap_area");
        roadmap_area?.style.setProperty("height", SetArrowHeight(roadmapRem) + "rem");

        // 横線の左右の向き設定
        let lines = document.querySelectorAll('.line_auto');
        lines.forEach((line) => {
            
            let line_year = line.id.slice(-4);
            if (parseInt(line_year) % 2 == 1)
            {
                if (mediaCheck.matches)
                {
                    line.classList.add('left');
                }
                else
                {
                    line.classList.remove('left');
                }
            }
        })
    }
        
    return (
        <>
            <title>PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>
            <div id="opening">
                <p className="opnening_logo"><img src="./assets/img/logo.png" alt="PROJECT ZIRCON（プロジェクト ジルコン）" width="258" height="96" /></p>
                <p className="opnening_txt"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/opening_txt.png`} alt="冒険と創造の毎日を。" width="1132" height="123" /></p>
                <p className="opnening_txt_sp1"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/catch_main_top_sp.png`} alt="冒険と創造の" /></p>
                <p className="opnening_txt_sp2"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/catch_main_top_sp2.png`} alt="毎日を。" /></p>
            </div>
            <Header />
            {/*左下固定のポップアップ呼び出しボタン*/}
            {
                LanguageUtils.getLanguage() == "ja" ? 
                
                <button id = "id-popup-start-button" className="popup-start-button" type="button" onClick={() => setIsOpenPopup(true)} ref={buttonRef}>
                    <img src="./assets/img/top/popup_icon.png" alt="ポップアップボタン" />
                </button>
                :
                <div></div>
            }

            {/*ポップアップ*/}
            <div>
                {isOpenPopup && (
                    <div className="popup-overlay">
                        <div className="popup-window">
                            <button className="popup-close-button" onClick={() => setIsOpenPopup (false)}>×</button>
                            <div className="popup-content">
                            <img src="./assets/img/top/popup_backgroud.png" alt="背景" className="popup-background-image" />

                            <div className="slide_wrap" >
                                {<>{TopPopupSlider(popupImageArray, setActiveIndex, swiperRef,allowPrev, setAllowNext,allowPrev, setAllowNext)}</>}
                                {   // 最後の画像の時は右矢印非表示
                                    activeIndex < popupImageArray.length - 1 && (<div ref={nextRef} className="swiper-button-next swiper-button-next-popup"></div>)
                                }
                                {   // 1枚目の画像の時は左矢印非表示
                                    activeIndex > 0 && (<div ref={prevRef} className="swiper-button-prev swiper-button-prev-popup"></div>)
                                }
                                <div className="swiper-pagination swiper-pagination-popup"></div> 
                                <link rel="stylesheet" href="./assets/css/top.min.css" />
                            </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div id="mainContent" className="wrapper">
                <div className="gem_wrap back">
                    <div className="gem" id="gem_back"></div>
                </div>
                <div className="gem_wrap front">
                    <div className="gem" id="gem_front"></div>
                </div>
                <header id="incHd"></header>
                <main>
                    <section className="hero_area">
                        <picture>
                            <div className="draw-sp">
                                <p className="main_catch"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/catch_main_top_sp.png`} alt="冒険と創造の" /></p>
                                <img src="./assets/img/top/top_kv_sp.png" alt="キービジュアル" style={{marginTop: '50px', marginBottom: '50px'}} />

                                {
                                    LanguageUtils.getLanguage() == "ja" ?
                                        <p className="main_catch_sp"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/catch_main_top_sp2.png`} alt="毎日を。" /></p> :
                                        <p className="main_catch_sp_en"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/catch_main_top_sp2.png`} alt="毎日を。" /></p>
                                }
                            </div>
                            <div className="draw-pc">
                                <img src="../assets/img/top/top_kv_pc.png" alt="キービジュアル" />
                            </div>
                        </picture>
                    </section>
                    <section className="about_btn_area">
                        <p className="btn_about"><a href="./game/"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/btn_about.png`} alt="PROJECT ZIRCONとは？" width="719" height="134" /></a></p>
                    </section>
                    <section className="movie_area">
                        <div className="inner">
                            <p className="catch blur">
                                {
                                    LanguageUtils.getLanguage() == "ja" ? 
                                    <picture>
                                        <source srcSet={`./assets/img/top/${LanguageUtils.getLanguage()}/mov_catch.svg`} media="(min-width: 769px)" />
                                        <img src={`./assets/img/top/${LanguageUtils.getLanguage()}/mov_catch_sp.svg`} alt="新作ゲームをみんなで創る" width="625" height="238" />
                                        </picture>
                                        :
                                        <picture>
                                        <source srcSet={`./assets/img/top/${LanguageUtils.getLanguage()}/mov_catch.png`} media="(min-width: 769px)" />
                                        <img src={`./assets/img/top/${LanguageUtils.getLanguage()}/mov_catch_sp.png`} alt="新作ゲームをみんなで創る" width="600" height="250" />
                                        </picture>
                                }
                            </p>
                            <div className="mov_wrap blur">
                                <button className="mov modal_yt_thumb01" type="button"><img src={`./assets/img/top/common/${LanguageUtils.getLanguage()}/mov_thumbnail.png`} alt="PROJECT ZIRCON（プロジェクト ジルコン）PV" /></button>
                            </div>
                            <p className="lead blur" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().top_about}}></p>
                        </div>
                        <div className="modal_yt01 modal_yt modal_area">
                            <div className="modal_overlay"></div>
                            <div className="modal_inner">
                                <button className="modal_cross" type="button"></button>
                                <div id="modal_btn_yt01"></div>
                            </div>
                        </div>
                    </section>
                    {
                        LanguageUtils.getLanguage() == "ja" ? 
                            <section className="banner_area">
                                <div className="slide_wrap">
                                    {<>{TopBannerSlider(props.bannerData)}</>}
                                    <div className="swiper-button-next swiper-button-next-banner"></div>
                                    <div className="swiper-button-prev swiper-button-prev-banner"></div>
                                    <div className="swiper-pagination swiper-pagination-banner"></div> 

                                    <link rel="stylesheet" href="./assets/css/top.min.css" />
                                </div>
                            </section>
                            :
                            <section className="banner_area_en">
                                <p className="english-banner-img"><img src="./assets/img/top/en_hp_allcreative.png" alt="" /></p>
                                <p className="english-banner-img-sp"><img src="./assets/img/top/en_hp_allcreative_sp.png" alt="" /></p>
                            </section>
                    }
                    <section className="information_area">
                        <div className="inner">
                            <h2 className="sec_ttl blur">
                                <span className="en">Official X</span>
                                <span className="jp">{LanguageUtils.getLanguageData().top_infomation}</span>
                            </h2>

                            <div className="post-x-area fadeup">
                                {
                                    LanguageUtils.getLanguage() == "ja" ? 
                                    <blockquote className="twitter-tweet">
                                        <p lang="ja" dir="ltr">【新作ゲーム】新作ローグライクカードゲーム『PROJECT ZIRCON』の最新情報を解禁！<br/>:white_check_mark:STEAM®ウィッシュリスト登録開始:white_check_mark:<a href="https://t.co/FILslVPhtx">https://t.co/FILslVPhtx</a><br/>ゲームの最新情報はこちら(＠ZIRCON_GAME)から！<a href="https://x.com/hashtag/KonamiPressStart?src=hash&amp;ref_src=twsrc%5Etfw">#KonamiPressStart</a><a href="https://x.com/hashtag/PROJECTZIRCON?src=hash&amp;ref_src=twsrc%5Etfw">#PROJECTZIRCON</a><a href="https://x.com/hashtag/%E6%96%B0%E4%BD%9C%E3%82%B2%E3%83%BC%E3%83%A0?src=hash&amp;ref_src=twsrc%5Etfw">#新作ゲーム</a> <a href="https://t.co/NVsAbs9A4n">pic.twitter.com/NVsAbs9A4n</a></p>&mdash; 【KONAMI】PROJECT ZIRCON公式［IP］ (@Project_Zircon) <a href="https://x.com/Project_Zircon/status/2095531010016399649?ref_src=twsrc%5Etfw">September 3, 2026</a>
                                    </blockquote>
                                    :
                                    <blockquote className="twitter-tweet">
                                        <p lang="en" dir="ltr">A new dark fantasy deckbuilding roguelike awaits…<br/>Wishlist PROJECT ZIRCON on Steam.<a href="https://t.co/rjDuT5KRNe">https://t.co/rjDuT5KRNe</a><a href="https://x.com/hashtag/WishForZircon?src=hash&amp;ref_src=twsrc%5Etfw">#WishForZircon</a> <a href="https://x.com/hashtag/KONAMI?src=hash&amp;ref_src=twsrc%5Etfw">#KONAMI</a> <a href="https://x.com/hashtag/roguelike?src=hash&amp;ref_src=twsrc%5Etfw">#roguelike</a> <a href="https://t.co/6QS3NifTHp">pic.twitter.com/6QS3NifTHp</a></p>&mdash; 【KONAMI】PROJECT ZIRCON -A ROGUELIKE CARD GAME- (@GAME_ZIRCON) <a href="https://x.com/GAME_ZIRCON/status/2095527244730958043?ref_src=twsrc%5Etfw">September 3, 2026</a>
                                    </blockquote>                                
                                }
                                <script async src="https://platform.x.com/widgets.js" charSet="utf-8"></script>
                            </div>

                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_05_2}}></p>
                            <div className="bnr fadeup">
                                {
                                    LanguageUtils.getLanguage() == "ja" ? (
                                        // 日本語版のX
                                        <a href="https://x.com/project_zircon" target="_blank"><img src="../assets/img/about/plan_bnr_x.png" alt="PROJECT ZIRCON 公式X" width="596" height="160"/></a>
                                    ) : (
                                        // 英語版のX
                                        <a href="https://x.com/GAME_ZIRCON" target="_blank"><img src="../assets/img/about/about_x_en.png" alt="PROJECT ZIRCON 公式X" width="596" height="160"/></a>
                                    )
                                }
                            </div>
                            {
                            /*
                            <div className="flx_box">
                                <div className="x_wrap faderight">
                                    <div className="x_timeline"><a className="twitter-timeline" data-chrome="noheader noscrollbar noborders" href="https://twitter.com/Project_Zircon?ref_src=twsrc%5Etfw">Tweets by Project_Zircon</a>
                                        <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
                                    </div>
                                </div>
                            </div>
                            */
                            }
                        </div>
                        <p className="bg_txt fadeleft"><img src="./assets/img/top/common/bg_txt_news_top.png" alt="News" width="750" height="221" /></p>
                        <div className="compass_wrap">
                            <p className="bg_compass"><img src="./assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058" /></p>
                        </div>
                    </section>
                    <section className="contact_area">
                        <div className="inner">
                            <h2 className="sec_ttl blur">
                                <span className="en">CONTACT</span>
                                <span className="jp">{LanguageUtils.getLanguageData().top_inquiry_title}</span>
                            </h2>
                            <p className="txt blur" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().top_inquiry_text}}></p>
                            <div className="btn_hexagon btn_about fadeup">
                                {
                                    LanguageUtils.getLanguage() == "ja" ? 
                                        <a href="https://www.konami.com/games/inquiry/jp/" rel="noopener noreferrer" target="_blank" className="btn_link">{LanguageUtils.getLanguageData().top_go_inquiry}</a>
                                        :
                                        <a href="https://www.konami.com/games/inquiry/global/" rel="noopener noreferrer" target="_blank" className="btn_link">{LanguageUtils.getLanguageData().top_go_inquiry}</a>
                                }
                            </div>
                        </div>
                        <p className="bg_txt fadeleft"><img src="./assets/img/top/common/bg_txt_contact_top.png" alt="Contact" width="906" height="229" /></p>
                    </section>
                </main>
                <footer id="incFt"></footer>
            </div>
    </>
    );
};

export default View;